import { createFileRoute } from '@tanstack/react-router'
import { WargaTable } from '../../../../components/WargaTable'

export const Route = createFileRoute('/platform/desa/$desaId/kependudukan')({
  component: () => {
    const { desaId } = Route.useParams()
    return <WargaTable desaId={desaId} />
  },
})
